module.exports = __webpack_public_path__ + "img/tenable-certezsa.369d12e9.svg";